/* unplugin-vue-components disabled */import { render } from "./ParamForm.vue?vue&type=template&id=ed3cef0e&scoped=true"
import script from "./ParamForm.vue?vue&type=script&lang=js"
export * from "./ParamForm.vue?vue&type=script&lang=js"

import "./ParamForm.vue?vue&type=style&index=0&id=ed3cef0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3cef0e"]])

export default __exports__